import { Outlet } from "react-router-dom";
import { useCity } from "@/contexts/CityContext";
import { useRoundsStatus } from "@/lib/rounds";
import BoardLocked from "@/pages/board/BoardLocked";
import "@/styles/rounds.css";

export function RoundsGate() {
  const { city } = useCity();
  const status = useRoundsStatus(city.slug);

  if (status.isLoading) {
    return <div className="pb-rounds-state" role="status">Checking Rounds access…</div>;
  }
  if (status.isError || !status.data) {
    return (
      <div className="pb-rounds-state pb-rounds-state--error" role="alert">
        <span>Rounds access could not be checked.</span>
        <button type="button" onClick={() => void status.refetch()}>Retry</button>
      </div>
    );
  }
  if (!status.data.open && !status.data.isAdmin) {
    return (
      <BoardLocked
        area="Rounds"
        memberCount={status.data.memberCount}
        threshold={status.data.threshold}
      />
    );
  }

  return <Outlet />;
}
